<template>
  <div class="collect-content">
    <div class="page-title">{{ $t('message.home.myFootprint') }}</div>
    <div v-loading="loading">
      <div class="list-content" v-if="list.length">
        <div class="item" v-for="item in list" :key="item.id" @click="goDetail(item)">
          <img :src="item.goodsThumbnail" alt="" class="goods-img" />
          <div class="goods-info">
            <div class="goods-name">{{ item.goodsName }}</div>
            <div class="goods-price">¥{{ item.goodsPrice }}</div>
            <div class="view-time">{{ item.viewTime }}</div>
          </div>
          <el-button size="mini" type="danger" plain @click.stop="deleteItem(item)">{{ $t('message.home.delete') }}</el-button>
        </div>
      </div>
      <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
    </div>
    <div class="common-pagination" v-if="total > 0">
      <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
        :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
    </div>
  </div>
</template>

<script>
import { listFootprint, deleteFootprint } from "@/api/upms/member_center";

export default {
  name: "MyFootprint",
  data() {
    return { loading: false, list: [], total: 0, queryParams: { pageNumber: 1, pageSize: 20 } }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      listFootprint(this.queryParams).then(r => {
        this.list = r.data?.data?.content || []
        this.total = r.data?.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() },
    goDetail(item) { this.$router.push('/productDetails?id=' + item.goodsId) },
    deleteItem(item) {
      this.$confirm(this.$t('message.home.confirmDelete'), this.$t('message.home.tips'), { type: 'warning' }).then(() => {
        deleteFootprint(item.id).then(() => { this.$message.success(this.$t('message.home.deleteSuccess')); this.loadData() })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.collect-content { padding: 24px 34px; }
.page-title { font-size: 20px; font-weight: bold; color: #333; margin-bottom: 20px; }
.list-content { display: flex; flex-direction: column; gap: 12px; }
.item { display: flex; align-items: center; gap: 16px; background: #fff; border-radius: 6px; padding: 14px; border: 1px solid #eee; }
.goods-img { width: 80px; height: 80px; border-radius: 6px; object-fit: cover; flex-shrink: 0; }
.goods-info { flex: 1; }
.goods-name { font-size: 14px; color: #303133; margin-bottom: 6px; }
.goods-price { font-size: 15px; font-weight: bold; color: #f56c6c; margin-bottom: 4px; }
.view-time { font-size: 12px; color: #909399; }
.common-pagination { margin-top: 20px; }
</style>
